import { render } from "./AuthenticationForm.vue?vue&type=template&id=0bf121f2"
import script from "./AuthenticationForm.vue?vue&type=script&lang=js"
export * from "./AuthenticationForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__